import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import Error404 from "modules/core/pages/Error404";

import { componentLazyImport } from "modules/core/utils/helpers";

import { insightsPrivateRoutesConstants as routesConstants } from "./routesConstants";

// Pages
const InsightsRepository = lazy(() =>
  componentLazyImport(() => import("../../pages/InsightsRepository"))
);
const SingleInsight = lazy(() =>
  componentLazyImport(() => import("../../pages/SingleInsight"))
);
const QueryEngine = lazy(() =>
  componentLazyImport(() => import("../../pages/QueryEngine"))
);
const ProjectStats = lazy(() =>
  componentLazyImport(() => import("../../pages/ProjectStats"))
);
const Roadmap = lazy(() =>
  componentLazyImport(() => import("../../pages/Roadmap"))
);

const InsightsPrivateRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path={routesConstants.single_insight.path}>
        <SingleInsight />
      </Route>

      <Route path={routesConstants.insights_repository.path}>
        <InsightsRepository />
      </Route>

      <Route path={routesConstants.roadmap.path}>
        <Roadmap />
      </Route>

      <Route path={routesConstants.query_engine.path}>
        <QueryEngine />
      </Route>

      <Route path={routesConstants.project_stats.path}>
        <ProjectStats />
      </Route>

      <Route>
        <Error404 />
      </Route>
    </Switch>
  );
};

export default InsightsPrivateRoutes;
